export default "__VITE_ASSET__578959c7__"